<template>
  <card-panel :paddinglessContent="true" class="complete-profile-container">
    <span slot="header-name">{{ profileCompletenessTitle }}</span>
    <div slot="content">
      <profile-completeness-progress-info v-if="showProfileCompletenessNotification" />
      <resume-management-container></resume-management-container>

      <div v-if="profileLoadingState" class="loader-container">
        <div class="loader"></div>
      </div>
      <div v-else>
        <card-panel-list :bordered="true">
          <profile-part-completeness
            v-for="(item, index) in candidateProfileCompleteness"
            :key="index"
            :label="item.label"
            :percentage="item.percentage"
            :edit-route="item.editRoute"
            @click="item.click">
          </profile-part-completeness>
        </card-panel-list>
        <div class="has-text-right">
          <button
            v-translate
            :class="{ 'is-loading': cvPreviewPdfLoadingState }"
            class="button is-primary small"
            @click="previewPDF">Preview PDF</button>
        </div>
      </div>
    </div>
  </card-panel>
</template>

<script>

import 'top20common/distribution/icons/edit';
import 'top20common/distribution/icons/plus';

import ProgressBar from 'top20common/components/ProgressBar';
import CardPanel from 'top20common/components/card-panel/CardPanel';
import CardPanelList from 'top20common/components/card-panel/CardPanelList';
import {mapGetters} from 'vuex';

import ResumeManagementContainer from '@/common/resume-management/ResumeManagementContainer';
import ProfileCompletenessProgressInfo from '@/pages/dashboard/components/ProfileCompletenessProgressInfo';
import profileParts from '@/services/profile-parts';

import ProfilePartCompleteness from './ProfilePartCompleteness';

export default {
  computed: {
    ...mapGetters([
      'profileDetailsState',
      'resumeState',
      'profileLoadingState',
      'cvPreviewPdfLoadingState',
      'isProfilePublished',
      'isProfileCompleted',
      'dismissedNotificationsState'
    ]),
    labels() {
      return {
        profileIncomplete: this.$gettext('Profile incomplete'),
        profilePending: this.$gettext('Profile pending'),
        profileComplete: this.$gettext('Profile complete')
      };
    },
    profileCompletenessTitle() {
      if (this.isProfilePublished && this.isProfileCompleted) {
        return this.labels.profileComplete;
      }

      return this.profileDetailsState.all_required_filled ? this.labels.profilePending : this.labels.profileIncomplete;
    },
    showProfileCompletenessNotification() {
      return (
        this.dismissedNotificationsState.indexOf('profile_completed') === -1 ||
        !(this.isProfilePublished && this.isProfileCompleted)
      );
    },
    candidateProfileCompleteness() {
      const completenessObject = this.profileDetailsState.profile_completeness || {};
      return profileParts.orderRoutes.map(item => {
        return {
          percentage: completenessObject[profileParts.routes[item].key] || 0,
          label: profileParts.routes[item].label,
          editRoute: profileParts.routes[item].editRoute,
          click: () => {
            this.editCompletenessClick(profileParts.routes[item].key.split('_').join(' '));
          }
        };
      });
    }
  },
  methods: {
    editCompletenessClick(trackLabel) {
      this.$mam.trackProfileCompletenessClick(trackLabel);
    },
    previewPDF() {
      this.$mam.trackPreviewPDFClicked(this.profileDetailsState.profile_completeness_progress);
      this.$store.commit('mutateCvPreviewPdfLoadingState', true);
      this.$store.dispatch('getProfileInBackgroundAction').then(response => {
        this.$store.commit('mutateCvPreviewPdfLoadingState', false);
        if (response.cv_url) {
          window.location.assign(response.cv_url);
          return;
        }

        this.$toast.open({
          message: this.$gettext("The PDF preview hasn't been generated yet. Please try again later."),
          type: 'is-danger'
        });
      });
    }
  },
  components: {
    ResumeManagementContainer,
    ProfilePartCompleteness,
    CardPanel,
    CardPanelList,
    ProgressBar,
    ProfileCompletenessProgressInfo
  }
};
</script>

<style lang="scss" scoped>
.margin-top {
  margin-top: 20px;
}

.general-completeness {
  white-space: nowrap;
}

.loader-container {
  padding: 0 20px 20px;
}

/deep/ .resume-management {
  padding: 0 20px;
  margin-bottom: 20px;
}

/deep/ .progress {
  width: 70px;
  height: 8px;
  margin: 0 5px 0 0;
}

button.is-primary.small {
  width: 120px;
  margin: 20px;
}
</style>
